import { Box, Skeleton } from "@mui/material";

interface MapSkeletonProps {
  height?: number | string;
}

const MapSkeleton = ({ height = 400 }: MapSkeletonProps) => {
  return (
    <Box
      sx={{
        width: "100%",
        height,
        borderRadius: 1,
        overflow: "hidden",
        position: "relative",
      }}
    >
      <Skeleton variant="rectangular" width="100%" height="100%" animation="wave" />
      <Box
        sx={{
          position: "absolute",
          inset: 0,
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          color: "text.secondary",
          fontSize: 14,
        }}
      >
        در حال بارگذاری نقشه...
      </Box>
    </Box>
  );
};

export default MapSkeleton;
